import { Routes } from '@angular/router';

export const CHECK_INS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/check-in-list.component').then(m => m.CheckInListComponent)
  },
  {
    path: 'create',
    loadComponent: () => import('./components/check-in-create.component').then(m => m.CheckInCreateComponent)
  },
  {
    path: ':id',
    loadComponent: () => import('./components/check-in-detail/check-in-detail.component').then(m => m.CheckInDetailComponent)
  }
];
